import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: "root"
})
export class ProductService {

  constructor(private httpService: HttpService) { }

  postProductList(objectPassed){
    const  url = `product`
    return this.httpService.postForShopService(url, objectPassed);
  }
  
  // postProductInfoGetUsingSlug(slugPassed){
  //   const  url = `product/${slugPassed}`
  //   return this.httpService.postForShopService(url, {slug: slugPassed});
  // }

  getProductInfoGetUsingId(idPassed){
    const  url = `product/${idPassed}`
    return this.httpService.getForShopService(url);
  }
  getProductInfoGetUsingSlug(slugPassed){
    const  url = `product/${slugPassed}`
    return this.httpService.getForShopService(url);
  }

  postProductCustomerRating(idPassed){
    const  url = `rating/product/count/${idPassed}`
    return this.httpService.getDigi(url);
  }

  postCategoryOfProducts(objectPassed){
    const  url = `category/used`
    return this.httpService.postForShopService(url, objectPassed);
  }
}
